
import {useState} from 'react'
import {useIntl} from 'react-intl'
import { KTSVG, toAbsoluteUrl } from '../../../../../_dashboard/helpers'
import { useLang } from '../../../../../_dashboard/i18n/Metronici18n'
import { useListView } from '../core/ListViewProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { getAll } from '../../../../services/common_requests'
import {HotelsListFilter} from './HotelListFilter'

const HotelsListToolbar = () => {
  const intl = useIntl()
  const {setItemIdForUpdate} = useListView()
  const {state: queryState} = useQueryRequest()
  const [exporting, setExporting] = useState<'csv' | 'excel' | null>(null)

  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }

  const exportHotels = async (exportAs: 'excel' | 'csv') => {
    try {
      setExporting(exportAs)
      const baseQuery: any = {
        ...queryState,
        page: 0,
        size: 500,
        includeInactive: true,
      }
      const all: any[] = []
      const pageSize = 500
      for (let p = 0; p < 2000; p++) {
        const res = await getAll({...baseQuery, page: p, size: pageSize}, '/hotels')
        const chunk = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []
        all.push(...chunk)
        if (chunk.length < pageSize) break
      }

      if (all.length === 0) {
        return
      }

      const {utils, writeFile} = await import('xlsx')
      const rows = all.map((h: any) => ({
        NAME: h?.name || '-',
        CITY: typeof h?.city === 'object' ? (h.city?.name || '-') : (h?.city || '-'),
        ADDRESS: h?.address || '-',
        EMAIL: h?.email || '-',
        PHONE: h?.phone || '-',
        'CREATED AT': h?.createDate ? new Date(h.createDate).toLocaleString() : '-',
      }))

      const ws = utils.json_to_sheet(rows)
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Hotels')

      const dateStr = new Date().toISOString().slice(0, 10)
      const ext = exportAs === 'csv' ? 'csv' : 'xlsx'
      const fileName = `hotels_${dateStr}.${ext}`

      if (exportAs === 'csv') {
        const csvContent = utils.sheet_to_csv(ws)
        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'})
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
      } else {
        writeFile(wb, fileName)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setExporting(null)
    }
  }

  const languages = [
    {
      lang: 'en',
      name: 'English',
      flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
    {
      lang: 'zh',
      name: 'Mandarin',
      flag: toAbsoluteUrl('/media/flags/china.svg'),
    },
    {
      lang: 'es',
      name: 'Spanish',
      flag: toAbsoluteUrl('/media/flags/spain.svg'),
    },
    {
      lang: 'ja',
      name: 'Japanese',
      flag: toAbsoluteUrl('/media/flags/japan.svg'),
    },
    {
      lang: 'de',
      name: 'German',
      flag: toAbsoluteUrl('/media/flags/germany.svg'),
    },
    {
      lang: 'fr',
      name: 'French',
      flag: toAbsoluteUrl('/media/flags/france.svg'),
    },
  ]
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div className='d-flex justify-content-end gap-2' data-kt-hotel-table-toolbar='base'>
        {/* begin::Filter */}
       {/* <HotelsListFilter />*/}
          {/* end::Filter */}

      {/* begin::Export */}
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        disabled={!!exporting}
        onClick={() => exportHotels('csv')}
      >
        <KTSVG path='/media/icons/duotune/files/fil021.svg' className='svg-icon-3 me-1' />
        {exporting === 'csv' ? '...' : intl.formatMessage({id: 'USERS.EXPORT.CSV', defaultMessage: 'Export CSV'})}
      </button>
      <button
        type='button'
        className='btn btn-light-primary btn-sm'
        disabled={!!exporting}
        onClick={() => exportHotels('excel')}
      >
        <KTSVG path='/media/icons/duotune/files/fil003.svg' className='svg-icon-3 me-1' />
        {exporting === 'excel' ? '...' : intl.formatMessage({id: 'USERS.EXPORT.EXCEL', defaultMessage: 'Export Excel'})}
      </button>
      {/* end::Export */}

      {/* begin::Add user */}

      {/* end::Add user */}
    </div>
  )
}

export {HotelsListToolbar}
